import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  background: rgba(102, 126, 234, 0.1);
  border: 1px solid #667eea;
  border-radius: 12px;
  padding: 15px;
  margin-bottom: 30px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
`;

const StandardLabel = styled.span`
  font-weight: 600;
`;

const StandardBadge = styled.span`
  background: rgba(102, 126, 234, 0.2);
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 0.9em;
  font-weight: 600;
  transition: all 0.3s ease;
  
  &:hover {
    background: rgba(102, 126, 234, 0.3);
    transform: translateY(-2px);
  }
`;

const StandardsBanner = () => {
  const standards = [
    'CSA CCM v4',
    'ISO 27001:2022',
    'NIST CSF 2.0',
    'CIS Controls v8',
    'SOC 2 Type II',
    'PCI DSS v4.0',
    'DORA',
    'NIS2'
  ];
  
  return (
    <Container>
      <StandardLabel>📋 Aligned with:</StandardLabel>
      {standards.map((standard, index) => (
        <StandardBadge key={index}>
          {standard}
        </StandardBadge>
      ))}
    </Container>
  );
};

export default StandardsBanner; 